import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { ComponentLoader } from '../../global/ComponentLoader/ComponentLoader';

import styles from './PdpSharedTradePointsEarnedMessage.scss';

const importFunc = () => {
    return import(
        /* webpackChunkName: "PointsEarnedMessageChunk" */
        'dibs-trade-rewards-progress/exports/PointsEarnedMessage'
    ).then(({ PointsEarnedMessage }) => PointsEarnedMessage);
};

function Placholder() {
    return <div className={styles.placeholder} />;
}

export function PdpSharedTradePointsEarnedMessageComponent(props) {
    const {
        item,
        priceInfoDisplay,
        tradeFirm,
        quantitySelected,
        viewer,
        isPdpFreeShippingFullTestVariant,
    } = props;

    if (!tradeFirm) {
        return null;
    }

    return (
        <div
            className={
                isPdpFreeShippingFullTestVariant
                    ? styles.containerFreeShippingTest
                    : styles.container
            }
        >
            <ComponentLoader
                importFunc={importFunc}
                load
                LoadingComponent={Placholder}
                useLoadingComponent={false}
                item={item}
                priceInfoDisplay={priceInfoDisplay}
                tradeFirm={tradeFirm}
                quantitySelected={quantitySelected}
                viewer={viewer}
                isPdpFreeShippingFullTestVariant={isPdpFreeShippingFullTestVariant}
            />
        </div>
    );
}

PdpSharedTradePointsEarnedMessageComponent.propTypes = {
    item: PropTypes.object,
    priceInfoDisplay: PropTypes.object,
    tradeFirm: PropTypes.object,
    quantitySelected: PropTypes.number,
    viewer: PropTypes.object,
    isPdpFreeShippingFullTestVariant: PropTypes.bool,
};

export const PdpSharedTradePointsEarnedMessage = createFragmentContainer(
    PdpSharedTradePointsEarnedMessageComponent,
    {
        priceInfoDisplay: graphql`
            fragment PdpSharedTradePointsEarnedMessage_priceInfoDisplay on PriceInfoDisplay {
                ...PointsEarnedMessage_priceInfoDisplay @include(if: $isTrade)
            }
        `,
        item: graphql`
            fragment PdpSharedTradePointsEarnedMessage_item on Item {
                ...PointsEarnedMessage_item @include(if: $isTrade)
            }
        `,
        tradeFirm: graphql`
            fragment PdpSharedTradePointsEarnedMessage_tradeFirm on TradeFirmType {
                ...PointsEarnedMessage_tradeFirm @include(if: $isTrade)
            }
        `,
        viewer: graphql`
            fragment PdpSharedTradePointsEarnedMessage_viewer on Viewer {
                ...PointsEarnedMessage_viewer @include(if: $isTrade)
            }
        `,
    }
);
